import memoize from "lodash.memoize";

const postcodeAllocation = ({ routes, planType }) => {
  const result = {};
  if (!routes) return result;

  routes.forEach((route) => {
    if (route.routeType !== planType) return;
    route.postcode.forEach((postcodeElement) => {
      const postcode = postcodeElement.postcode;
      if (result[postcode]) {
        result[postcode].push(route.routeCode);
      } else {
        result[postcode] = [route.routeCode];
      }
    });
    route.sector.forEach((sectorElement) => {
      const sector = sectorElement.postcodeSector;
      if (result[sector]) {
        result[sector].push(route.routeCode);
      } else {
        result[sector] = [route.routeCode];
      }
    });
    route.outer.forEach((outerElement) => {
      const outer = outerElement.postcodeOuter;
      if (result[outer]) {
        result[outer].push(route.routeCode);
      } else {
        result[outer] = [route.routeCode];
      }
    });
  });
  return result;
};

export const getPostcodeAllocation = memoize(postcodeAllocation);
